/**
 * Methods to facilitate the report download functionalities.
 */
import { sortByChannelComponent } from './sorting';
import { getUniqueCompositeKeys, deriveHeadingDisplayKey } from './composite_keys';

const DATASETS_COLUMN = 'DataSets';

export const reportDataByColumn = (reportData, groupingItems = []) => {
  const { reportHeadings, reportKeys, reportRows } = reportData;
  let dataToDownload = [];
  const sortedRows = sortAndFilter(reportRows, groupingItems);

  const rowsData = sortedRows
    .map((row) => reportKeys.map((k) => `"${row[k] ? row[k] : ''}"`))
    .map((row) => row.join('\t'));

  dataToDownload.push(reportHeadings.map((h) => `"${h}"`).join('\t'));
  dataToDownload.push(...rowsData);

  return dataToDownload;
};

export const reportDataByRow = (reportData, groupingItems) => {
  const { reportHeadings, reportKeys, reportRows } = reportData;
  let dataToDownload = [];

  const sortedRows = sortAndFilter(reportRows, groupingItems);
  const uniqueCompositeKeys = getUniqueCompositeKeys(reportKeys);

  let rowsData = [];
  uniqueCompositeKeys.forEach((compositeKey) => {
    const dataSetKey = deriveHeadingDisplayKey(compositeKey, uniqueCompositeKeys).replace('[', '').replace(']', '');
    const reportKeysForDataset = reportKeys.filter((k) => !k.startsWith('[') || k.startsWith(compositeKey));
    const rowDataForDataSet = sortedRows
      .map((row) => reportKeysForDataset.map((k) => `"${row[k] ? row[k] : ''}"`))
      .map((row) => [`"${dataSetKey}"`, ...row].join('\t'));

    rowsData.push(...rowDataForDataSet);
  });

  let headingData = [
    ...new Set(
      reportHeadings.map((h) => {
        return h.substring(h.lastIndexOf(']') + 1);
      })
    ),
  ];
  headingData.unshift(DATASETS_COLUMN);

  dataToDownload.push(headingData.map((h) => `"${h}"`).join('\t'));
  dataToDownload.push(...rowsData);

  return dataToDownload;
};

const sortAndFilter = (reportRows, groupingItems) => {
  return sortByChannelComponent(
    reportRows
      .filter((row) => row.visible && row.channel && !groupingItems.includes(row.component))
      .map((row) => {
        return {
          ...row,
          component: row.parentComponent ? `  ${row.parentComponent}/${row.component}` : row.component,
          channel: row.channel.toUpperCase(),
        };
      })
  );
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/download.js